import { render, staticRenderFns } from "./refund-policy.vue?vue&type=template&id=1899d7ee&scoped=true"
import script from "./refund-policy.vue?vue&type=script&lang=js"
export * from "./refund-policy.vue?vue&type=script&lang=js"
import style0 from "./refund-policy.vue?vue&type=style&index=0&id=1899d7ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1899d7ee",
  null
  
)

export default component.exports